import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-ink">
    <div className="max-w-7xl mx-auto px-6 py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
      <div className="md:col-span-5">
        <img src="/logo-full.png" alt="LUXGROOM Mobile Barber Technologies" className="w-48 md:w-56 h-auto" />
        <p className="mt-4 text-sm text-white/50 leading-relaxed max-w-sm">
          LUXGROOM Mobile Barber Technology — premium mobile grooming, delivered to your door.
          Home, office, hotel, and scheduled pop-up locations across San Francisco.
        </p>
      </div>
      <div className="md:col-span-4">
        <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">Contact</p>
        <ul className="space-y-4 text-sm text-white/60">
          <li>
            <a data-testid="footer-email-link" href="mailto:ltaplett@luxgroom.net" className="flex items-center gap-3 hover:text-gold transition-colors">
              <Mail size={15} className="text-gold" /> ltaplett@luxgroom.net
            </a>
          </li>
          <li>
            <a data-testid="footer-phone-link" href="tel:+14159946699" className="flex items-center gap-3 hover:text-gold transition-colors">
              <Phone size={15} className="text-gold" /> 415.994.6699
            </a>
          </li>
          <li className="flex items-center gap-3">
            <MapPin size={15} className="text-gold" /> San Francisco, California, USA
          </li>
        </ul>
      </div>
      <div className="md:col-span-3">
        <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">Explore</p>
        <ul className="space-y-4 text-sm text-white/60">
          <li><Link data-testid="footer-offer-link" to="/offer" className="hover:text-gold transition-colors">Book your visit</Link></li>
          <li><Link data-testid="footer-rebook-link" to="/rebook" className="hover:text-gold transition-colors">Returning client? Rebook</Link></li>
          <li><Link data-testid="footer-gift-link" to="/gift" className="hover:text-gold transition-colors">Gift a cut</Link></li>
          <li><Link data-testid="footer-express-link" to="/express" className="hover:text-gold transition-colors">Between meetings? Express</Link></li>
          <li><Link data-testid="footer-newsf-link" to="/new-to-sf" className="hover:text-gold transition-colors">New to San Francisco</Link></li>
          <li><Link data-testid="footer-hotels-link" to="/hotels" className="hover:text-gold transition-colors">For hotels &amp; concierges</Link></li>
          <li><Link data-testid="footer-join-link" to="/join" className="hover:text-gold transition-colors">Are you a barber?</Link></li>
          <li><Link data-testid="footer-privacy-link" to="/privacy" className="hover:text-gold transition-colors">Privacy Policy</Link></li>
          <li><Link data-testid="footer-terms-link" to="/terms" className="hover:text-gold transition-colors">Terms &amp; Conditions</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-white/40">
        <p>© 2026 LUXGROOM Mobile Barber Technology. All rights reserved.</p>
        <p className="flex gap-6">
          <Link data-testid="footer-privacy-link-bottom" to="/privacy" className="hover:text-gold transition-colors">Privacy</Link>
          <Link data-testid="footer-terms-link-bottom" to="/terms" className="hover:text-gold transition-colors">Terms</Link>
          <Link data-testid="footer-admin-link" to="/admin" className="hover:text-gold transition-colors">Admin</Link>
        </p>
      </div>
    </div>
  </footer>
);
